import { PlpTypes } from '../PlpListing';

/* eslint-disable no-unused-vars */
export interface PdpSingle {
  searchDate: string;
  identifier: string;
  title: string;
  pricing: Pricing;
  attributes: Attributes;
  media: MediaPdp[];
  description: string;
  seoDescription: string;
  location: Location;
  breadcrumbLinks: BreadcrumbLink[];
  status: number;
  jsonLdProduct: string | null;
  jsonLdBreadCrumb: string | null;
  jsonLdOrganization: string | null;
}

export interface Attributes {
  landuseType: string;
  propertyType: string;
  numBeds: number;
  specifics: string[];
  floorArea: number;
  floorAreaUnit: string;
  listingType: string;
}

export interface Specific {
  id: number;
  name: string;
  type: string;
}

export interface BreadcrumbLink {
  name: string;
  linkUrl: string;
  index: number;
}

export interface Location {
  locationName: string;
  longitude: number;
  latitude: number;
}

export interface MediaPdp {
  type: string;
  photoSmallUrl: string;
  photoLargeUrl: string;
  isCover: boolean;
}


export interface PdpContactInfo {
  type: string;
  fullName: string;
  callNumber: string;
  departmentName: string;
  departmentLogoUrl: string;
  departmentId: number;
  whatsappAvailibility: boolean;
}

// similar

export interface SimilarListing {
  content: PlpTypes.GListingContent[];
}

export interface AttributesSimilar {
  landuseType: string;
  propertyType: string;
  numBeds: number;
  numOfBaths: number;
  listingType: string;
}

export interface ContactInfo {
  type: ContactInfoType;
  logoUrl: string;
  name?: string;
}

export enum ContactInfoType {
  Agency = 'AGENCY',
  Agent = 'AGENT',
}

export interface Location {
  locationName: string;
  longitude: number;
  latitude: number;
  targetGlobalLocation: {
    id: number;
    type: string;
  };
}

export interface Media {
  imageUrls: string[];
  imageCount: number;
}

export interface PricingSimilar {
  price: number | null;
  currency: string | null;
  agreedPrice: boolean | null;
  capRatePercentage?: number;
}

//new types

export interface NewSimilarListing {
  data: NewSimilarListingResponse;
}

export interface NewSimilarListingResponse {
  data: PlpTypes.NewGListingContent[],
  error: string | null,
  traceId: string
}



export interface Pricing {
  price: number| null | undefined;
  deposit: number| null | undefined;
  rent: number| null | undefined;
  unitPrice: number| null | undefined;
  currency: string| null | undefined;
  agreedPrice: boolean| null | undefined;
  depositOnly: boolean| null | undefined;
  capRatePercentage: number| null | undefined;
  listingType: string
}
interface AgencyInfo {
  agencyType: string;
  id: number;
  logo: string;
  name: string;
}
interface BreadCrumb {
  url: string;
  title: string;
}
interface Point {
  type: string; // مثلاً 'POINT'
  coordinate: [number, number]; // آرایه‌ای از دو عدد برای مختصات
}
export interface NewListing {
  age: number;
  agency: AgencyInfo;
  agreedPrice: boolean;
  breadCrumbs: BreadCrumb[];
  depositOnly: null | boolean; // می‌تواند null یا boolean باشد
  description: string;
  elevator: boolean;
  expired: boolean;
  featured: boolean;
  features: string[]; // آرایه‌ای از ویژگی‌ها
  floor: null | number; // می‌تواند null یا عدد باشد
  floorArea: number; // مساحت
  id: number; // شناسه لیستینگ
  landuseType: string; // نوع استفاده از زمین
  listingType: string; // نوع لیست
  location: string; // موقعیت مکانی
  locationId: number; // شناسه موقعیت
  locationType: string; // نوع موقعیت
  metaData: null; // ویژگی‌های اضافی یا null
  municipalAreaNum: number; // شماره منطقه شهری
  newBuild: boolean; // آیا ساختمان جدید است؟
  numBeds: number; // تعداد اتاق خواب
  numOfPictures: number; // تعداد تصاویر
  numParkings: null | number; // تعداد پارکینگ یا null
  pictures: string[]; // آرایه‌ای از URL تصاویر
  point: Point; // مختصات
  priceOrDeposit: number; // قیمت یا ودیعه
  propertyType: string; // نوع ملک
  searchDate: number; // تاریخ جستجو
  tags: string[]; // آرایه‌ای از برچسب‌ها
  title: string; // عنوان
  unitPriceOrRent: null | number; // قیمت یا اجاره یا null
  warehouse: boolean; // آیا انباری دارد؟
  yearBuilt: number; // سال ساخت
  trueCheck?:boolean
}
export interface NewPdpSingle {
  listing: NewListing;
  pois:[],
  similar:PlpTypes.NewGListingContent[],
  breadCrumbs: BreadCrumb[],
  moreSimilarLink: string,
}
export interface NewPdpSingleResponse {
  data: NewPdpSingle,
  error: {
    code: string
    msg: string
    detail: []
  } | null,
  traceId: string
}


